module.exports = __webpack_public_path__ + "static/media/down-chevron.08b4db62.svg";